module.exports = __webpack_public_path__ + "static/media/top-img_1.ab2330ea.jpg";